export default "__VITE_ASSET__ChCfWCal__"